import React from 'react';
import { Input } from '../../../components/ui/input';
import { hslToHex } from './color-helpers';
import { THEME_STYLE_DEFAULTS } from './theme-constants';
import styles from './ThemeTab.module.css';
import type { ColorFieldGridProps } from './theme-types';

export const ColorFieldGrid: React.FC<ColorFieldGridProps> = ({ fields, resolveToken, onChange }) => (
  <div className={styles.colorGrid}>
    {fields.map(field => {
      const hslValue = resolveToken(field.key);
      const hexValue = hslValue ? hslToHex(hslValue) : '#000000';

      return (
        <div key={field.key}>
          <label htmlFor={`theme-${field.key}`}>{field.label}</label>
          <label className={styles.swatch}>
            <span aria-hidden="true" style={{ backgroundColor: hexValue }} />
            <input
              type="color"
              value={hexValue}
              onChange={e => onChange(field.key, e.target.value)}
              title="Pick a color"
            />
          </label>
          <Input
            id={`theme-${field.key}`}
            value={hslValue}
            onChange={e => onChange(field.key, e.target.value)}
            placeholder={`e.g., ${THEME_STYLE_DEFAULTS[field.key]}`}
          />
        </div>
      );
    })}
  </div>
);
